export default from './Checkbox';



// WEBPACK FOOTER //
// ./src/sharedComponents/Checkbox/index.js